import { render, staticRenderFns } from "./RegisterPixKey.vue?vue&type=template&id=b1e3029e&"
import script from "./RegisterPixKey.vue?vue&type=script&lang=js&"
export * from "./RegisterPixKey.vue?vue&type=script&lang=js&"
import style0 from "./RegisterPixKey.vue?vue&type=style&index=0&id=b1e3029e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports